<template>
  <div class="as-container">
    <h1 class="title">Спасибо за обращение</h1>
    <p class="paragraph">
      На указанный Вами адрес электронной почты было отправлено письмо. Для
      продолжения регистрации перейдите по ссылке, указанной в письме.
    </p>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.as-container {
  color: #ffffff;
  text-align: center;
}

.title {
  margin-bottom: 30px;
}

.paragraph {
  margin-bottom: 15px;
}

.button {
  margin: 30px auto 0;
  width: 200px;
  padding: 10px 20px;
}
</style>
